module.exports = __webpack_public_path__ + "img/gi_balapliar.551e702b.png";